/*
 * $1 Keychain promo: max 2 of the promo keychain variant per cart.
 *
 * Config comes from snippets/kc-promo-config.liquid (window.KC_PROMO). When the promo window
 * has closed that snippet prints nothing and this file does nothing.
 *
 * Only the promo variant is ever touched. Other products, other keychains, the keychain +
 * sticker combo, Mini Plate Keychains and the free-shipping logic are never inspected or changed.
 *
 * What it guards (all in the browser):
 *   1. cart add (product page, quick add, any fetch to /cart/add): blocked if cart + requested > 2
 *   2. cart change / update (quantity box, typing, remove-then-add): blocked if the new quantity > 2
 *   3. the + button and typed quantities on the product page and in the cart / cart drawer
 *   4. a cart that somehow already holds more than 2 is reduced to 2 on the next page load
 * Message everywhere: "Limit 2 per customer during this promotion."
 */
(function () {
  var C = window.KC_PROMO;
  if (!C || !C.variantId || Date.now() >= C.endsAt) return;

  var VID = String(C.variantId);
  var MAX = C.max || 2;
  var MSG = C.message || 'Limit 2 per customer during this promotion.';
  var nativeFetch = window.fetch.bind(window);
  var cartQty = 0;

  /* ---------- helpers ---------- */

  function json(status, obj) {
    return new Response(JSON.stringify(obj), { status: status, headers: { 'Content-Type': 'application/json' } });
  }

  function blocked() {
    return json(422, { status: 422, message: 'Cart Error', errors: MSG, description: MSG });
  }

  function getCart() {
    return nativeFetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store',
    }).then(function (r) {
      return r.json();
    });
  }

  function qtyOf(cart) {
    var n = 0;
    (cart.items || []).forEach(function (i) {
      if (String(i.variant_id) === VID) n += i.quantity;
    });
    return n;
  }

  function refresh() {
    return getCart()
      .then(function (c) {
        cartQty = qtyOf(c);
        return c;
      })
      .catch(function () {
        return null;
      });
  }

  function baseVariant(id) {
    return String(id).split(':')[0];
  }

  /* ---------- message UI ---------- */

  var style = document.createElement('style');
  style.textContent =
    '.kc-limit-msg{margin:.8rem 0 0;font-size:1.3rem;line-height:1.4;font-weight:600;color:#7FA8DB;letter-spacing:.04rem}' +
    '.kc-limit-toast{position:fixed;left:50%;bottom:90px;transform:translateX(-50%);z-index:10001;max-width:calc(100vw - 32px);' +
    'padding:1rem 1.6rem;border-radius:6px;background:#1a1a1a;border:1px solid #35649B;color:#fff;font-size:1.3rem;font-weight:600;text-align:center}';
  document.head.appendChild(style);

  /* Puts the message in normal flow BELOW the quantity control row, never inside a flex row. */
  function showMsg(qi) {
    var anchor = qi;
    while (
      anchor.parentElement &&
      anchor.parentElement !== document.body &&
      /flex|grid/.test(getComputedStyle(anchor.parentElement).display)
    ) {
      anchor = anchor.parentElement;
    }
    var host = anchor.parentElement;
    if (!host || host === document.body) return showToast();
    var existing = host.querySelector(':scope > .kc-limit-msg');
    if (existing) existing.remove();
    var p = document.createElement('p');
    p.className = 'kc-limit-msg';
    p.setAttribute('role', 'alert');
    p.textContent = MSG;
    anchor.insertAdjacentElement('afterend', p);
    setTimeout(function () {
      if (p.parentNode) p.remove();
    }, 5000);
  }

  function showToast() {
    var t = document.createElement('div');
    t.className = 'kc-limit-toast';
    t.setAttribute('role', 'alert');
    t.textContent = MSG;
    document.body.appendChild(t);
    setTimeout(function () {
      t.remove();
    }, 5000);
  }

  /* ---------- request guard ---------- */

  function kvToItems(pairs) {
    var grouped = {};
    var flat = {};
    pairs.forEach(function (kv) {
      var m = /^items\[(\d+)\]\[(id|quantity)\]$/.exec(kv[0]);
      if (m) {
        grouped[m[1]] = grouped[m[1]] || {};
        grouped[m[1]][m[2]] = kv[1];
      } else if (kv[0] === 'id' || kv[0] === 'quantity') {
        flat[kv[0]] = kv[1];
      }
    });
    var items = Object.keys(grouped).map(function (k) {
      return grouped[k];
    });
    if (flat.id) items.push(flat);
    return items;
  }

  function parseBody(body) {
    if (!body) return null;
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      var pairs = [];
      body.forEach(function (v, k) {
        pairs.push([k, String(v)]);
      });
      return { kind: 'pairs', pairs: pairs };
    }
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      var p2 = [];
      body.forEach(function (v, k) {
        p2.push([k, v]);
      });
      return { kind: 'pairs', pairs: p2 };
    }
    if (typeof body === 'string') {
      try {
        return { kind: 'json', data: JSON.parse(body) };
      } catch (e) {
        var p3 = [];
        new URLSearchParams(body).forEach(function (v, k) {
          p3.push([k, v]);
        });
        return { kind: 'pairs', pairs: p3 };
      }
    }
    return null;
  }

  function requestedForAdd(parsed) {
    var items = parsed.kind === 'json' ? (parsed.data.items ? parsed.data.items : [parsed.data]) : kvToItems(parsed.pairs);
    var n = 0;
    items.forEach(function (it) {
      if (it && it.id && baseVariant(it.id) === VID) n += parseInt(it.quantity, 10) || 1;
    });
    return n;
  }

  function guardAdd(parsed) {
    var wanted = requestedForAdd(parsed);
    if (!wanted) return Promise.resolve(null);
    return getCart().then(function (cart) {
      return qtyOf(cart) + wanted > MAX ? blocked() : null;
    });
  }

  function guardChange(parsed) {
    if (parsed.kind !== 'json') return Promise.resolve(null);
    var d = parsed.data;
    var q = parseInt(d.quantity, 10);
    if (!(q > MAX)) return Promise.resolve(null);
    if (d.id) return Promise.resolve(baseVariant(d.id) === VID ? blocked() : null);
    if (d.line) {
      return getCart().then(function (cart) {
        var item = cart.items[d.line - 1];
        return item && String(item.variant_id) === VID ? blocked() : null;
      });
    }
    return Promise.resolve(null);
  }

  function guardUpdate(parsed) {
    var updates = parsed.kind === 'json' ? parsed.data.updates : null;
    if (!updates) {
      if (parsed.kind !== 'pairs') return Promise.resolve(null);
      updates = {};
      parsed.pairs.forEach(function (kv) {
        var m = /^updates\[(.+)\]$/.exec(kv[0]);
        if (m) updates[m[1]] = kv[1];
      });
    }
    var hit = false;
    var needsCart = Array.isArray(updates);
    if (!needsCart) {
      Object.keys(updates).forEach(function (k) {
        if (baseVariant(k) === VID && parseInt(updates[k], 10) > MAX) hit = true;
      });
      return Promise.resolve(hit ? blocked() : null);
    }
    return getCart().then(function (cart) {
      updates.forEach(function (q, i) {
        var item = cart.items[i];
        if (item && String(item.variant_id) === VID && parseInt(q, 10) > MAX) hit = true;
      });
      return hit ? blocked() : null;
    });
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url ? input.url : '';
    var path = url;
    try {
      path = new URL(url, window.location.origin).pathname;
    } catch (e) {}
    var m = /\/cart\/(add|change|update)(\.js)?$/.exec(path);
    if (!m) return nativeFetch(input, init);

    var kind = m[1];
    var parsed = parseBody(init && init.body);
    if (!parsed) return nativeFetch(input, init);

    var guard = kind === 'add' ? guardAdd(parsed) : kind === 'change' ? guardChange(parsed) : guardUpdate(parsed);
    return guard
      .catch(function () {
        return null;
      })
      .then(function (blockedResponse) {
        if (blockedResponse) return blockedResponse;
        return nativeFetch(input, init).then(function (res) {
          refresh();
          return res;
        });
      });
  };

  /* ---------- quantity controls (+ button and typed values) ---------- */

  function inputVariant(input) {
    if (input.dataset && input.dataset.quantityVariantId) return String(input.dataset.quantityVariantId);
    var form = input.form || input.closest('form');
    var idField = form && form.querySelector('[name="id"]');
    return idField ? baseVariant(idField.value) : '';
  }

  function isCartInput(input) {
    return !!(input.dataset && input.dataset.quantityVariantId) || /^updates\[/.test(input.name || '');
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest ? e.target.closest('quantity-input button[name="plus"]') : null;
      if (!btn) return;
      var qi = btn.closest('quantity-input');
      var input = qi && qi.querySelector('input');
      if (!input || inputVariant(input) !== VID) return;
      var current = parseInt(input.value, 10) || 0;
      var alreadyInCart = isCartInput(input) ? 0 : cartQty;
      if (current + 1 + alreadyInCart > MAX) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showMsg(qi);
      }
    },
    true
  );

  document.addEventListener(
    'change',
    function (e) {
      var input = e.target;
      if (!input || !input.matches || !input.matches('quantity-input input')) return;
      if (inputVariant(input) !== VID) return;
      var value = parseInt(input.value, 10) || 0;
      var cartInput = isCartInput(input);
      var alreadyInCart = cartInput ? 0 : cartQty;
      if (value + alreadyInCart > MAX) {
        e.stopImmediatePropagation();
        e.preventDefault();
        input.value = cartInput ? input.getAttribute('value') || MAX : Math.max(1, MAX - alreadyInCart);
        showMsg(input.closest('quantity-input'));
      }
    },
    true
  );

  /* ---------- safety net: a cart already above the limit is reduced to the limit ---------- */

  function clampExisting(cart) {
    if (!cart || qtyOf(cart) <= MAX) return;
    var once = false;
    try {
      once = sessionStorage.getItem('kc_clamped') === '1';
      sessionStorage.setItem('kc_clamped', '1');
    } catch (e) {}
    if (once) return;
    nativeFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: VID, quantity: MAX }),
    }).then(function (r) {
      if (r.ok) {
        try {
          sessionStorage.setItem('kc_toast', '1');
        } catch (e) {}
        window.location.reload();
      }
    });
  }

  function init() {
    try {
      if (sessionStorage.getItem('kc_toast') === '1') {
        sessionStorage.removeItem('kc_toast');
        sessionStorage.removeItem('kc_clamped');
        showToast();
      }
    } catch (e) {}
    refresh().then(clampExisting);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refresh();
  });
})();
